// LIBRARIES
import styled, { css, keyframes } from "styled-components";

// STYLES
import { COLORS, MARGIN, SIZE, BORDER_RADIUS } from "constants/variables";

// ASSETS
import cursorIcon from "assets/img/Cursor.png";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const CardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  align-items: center;
  padding: ${SIZE.max24} ${MARGIN.fix32};
`;

export const Card = styled.div`
  background-color: ${COLORS.Crimson};
  padding: 16px 20px;
  border-radius: 16px;
  cursor: pointer;
  min-width: 130px;
  text-align: center;
  transition: transform 0.2s ease;
  &:hover {
    transform: scale(1.1);
  }
`;

// Mobile Dropdown Styles
export const DropdownContainer = styled.div`
  width: 100%;
  padding: ${SIZE.max24} ${MARGIN.fix32};
  background-color: ${COLORS.Background};
  position: relative;
  display: flex;
  justify-content: center;
`;

export const DropdownButton = styled.div<{ isOpen: boolean }>`
  background-color: ${COLORS.Crimson};
  padding: ${SIZE.max12} ${SIZE.max24};
  border-radius: ${BORDER_RADIUS.radius21};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  min-width: 200px;
  text-align: center;
  
  &:hover {
    background-color: ${COLORS.VividAuburn};
  }
  
  span {
    margin-left: ${SIZE.max12};
    font-size: 14px;
    transition: transform 0.3s ease;
    transform: ${({ isOpen }) => isOpen ? 'rotate(180deg)' : 'rotate(0)'};
  }
`;

export const DropdownList = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  width: 90%;
  max-width: 400px;
  overflow: hidden;
  z-index: 1000;
  padding: ${SIZE.max28};
  background-color: ${COLORS.Cultured};
  outline: 8px solid ${COLORS.MetalicSilver}4d;
  border-radius: ${BORDER_RADIUS.radius32};
  margin: 0 auto;
  animation: ${({ isOpen }) =>
    isOpen
      ? css`
          ${fadeIn} 0.3s ease-out
        `
      : css`
          ${fadeOut} 0.3s ease-out
        `};
  transform-origin: top center;
  
  /* Custom scrollbar container */
  & > div {
    max-height: 300px;
    overflow-y: auto;
    padding-right: 4px; /* Space for scrollbar */
    
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      margin: 8px 0;
    }

    &::-webkit-scrollbar-thumb {
      background: ${COLORS.Yellow};
      border-radius: ${BORDER_RADIUS.radius8};
    }
  }
`;

export const DropdownItem = styled.div`
  padding: ${SIZE.max12} ${SIZE.max24};
  cursor: pointer;
  transition: background-color 0.2s;
  color: ${COLORS.RaisinBlack};
  
  &:hover {
    background-color: ${COLORS.ChineseSilver};
  }
  
  &:first-child {
    padding-top: ${SIZE.max16};
    border-radius: ${BORDER_RADIUS.radius16} ${BORDER_RADIUS.radius16} 0 0;
  }
  
  &:last-child {
    padding-bottom: ${SIZE.max16};
    border-radius: 0 0 ${BORDER_RADIUS.radius16} ${BORDER_RADIUS.radius16};
  }
`;
